export default __webpack_public_path__ + "static/media/game-line-4.b97f97a7.png";